import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteUrl } from '../../../hooks/use-route-url';
import { Order } from '../../../common/model/dto/order/order';
import { OrderBy } from '../../../common/types';
import { isFailedOrder } from '../../../common/utils/services/order-status-utils';
import { useOrderListColumns } from '../../../hooks/use-order-list-columns';
import OvOrderListCard from './OvOrderListCard';
import OvRecordList from './OvRecordList';

interface OvOrderListProps {
  orders: Order[];
  orderBy: string;
  orderDir: string;
  onSort: (order: OrderBy) => void;
}

const OvOrderList: FC<OvOrderListProps> = ({
  orders,
  orderBy,
  orderDir,
  onSort,
}) => {
  const { t } = useTranslation();
  const url = useRouteUrl();
  const columns = useOrderListColumns();

  return (
    <OvRecordList
      label={t('app.subPages.menu.orders')}
      records={orders}
      columns={columns}
      getKey={(order) => order.id ?? ''}
      getDetailsPath={(order) => `${url}/${order.id}`}
      getRowPresentation={(order) => ({
        isFlagged: isFailedOrder(order.status),
      })}
      renderCard={(order, detailsPath = '') => (
        <OvOrderListCard order={order} detailsPath={detailsPath} />
      )}
      orderBy={orderBy}
      orderDir={orderDir}
      onSort={onSort}
    />
  );
};

export default OvOrderList;
